<script>
  import { Line, mixins, generateChart } from 'vue-chartjs'
  import Chart from 'chart.js'

  let currentLineItem

  Chart.defaults.LineWithLine = Chart.defaults.line;
  Chart.controllers.LineWithLine = Chart.controllers.line.extend({
    draw: function (ease) {
      Chart.controllers.line.prototype.draw.call(this, ease)
      if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
        var activePoint = this.chart.tooltip._active[0],
          ctx = this.chart.ctx,
          x = activePoint.tooltipPosition().x,
          yAxisId = activePoint._yScale.id,
          topY = this.chart.scales[yAxisId].top,
          bottomY = this.chart.scales[yAxisId].bottom
        // draw line
        ctx.save()
        ctx.beginPath()
        ctx.moveTo(x, topY)
        ctx.lineTo(x, bottomY)
        ctx.lineWidth = 1
        ctx.strokeStyle = '#07C'
        ctx.stroke()
        ctx.restore()
        // Call the onLineDraw callback if present
        let onLineDrawCallback = this.chart.controller.config.options.onLineDraw
        if (onLineDrawCallback) {
          let item = this.chart.controller.config.data.labels[activePoint._index]
          // Temporary store the item to prevent excessive firing.
          if (item && item !== currentLineItem) {
            onLineDrawCallback(item)
            currentLineItem = item
          }
        }
      }
    }
  })
  const CustomLine = generateChart('custom-line', 'LineWithLine')

  export default {
    extends: CustomLine,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>

<style>
</style>
